import {
  Checkbox,
  TableCell,
  TableCheckboxCell,
  TableRow,
  Badge,
  Text,
  Flex
} from '@woorcs/design-system'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { useAuth } from '@app/auth'

import { TagBadge } from '../../TagBadge'
import { UserListUserFragment } from '../__generated__/UserListFragments'

import { UserRowMenu } from './Menu'

interface UserRowProps {
  user: UserListUserFragment
  isSelected: boolean
  onSelect(id: string): void
  onRemove(id: string): void
  onDisable(user: UserListUserFragment): void
}

export const UserRow = ({
  user,
  isSelected,
  onSelect,
  onRemove,
  onDisable
}: UserRowProps) => {
  const { t } = useTranslation()
  const [authState] = useAuth()
  const isViewer = authState.user?.id === user.id

  const handleRemoveUser = useCallback(() => {
    onRemove(user.id)
  }, [onRemove, user.id])

  const handleDisableUser = useCallback(() => {
    onDisable(user)
  }, [onDisable, user])

  return (
    <TableRow>
      <TableCheckboxCell>
        <Checkbox
          disabled={isViewer}
          checked={isSelected}
          onChange={() => onSelect(user.id)}
        />
      </TableCheckboxCell>
      <TableCell>
        <NavLink to={`/users/${user.id}`}>
          <Text
            as='span'
            color='grey.900'
            __css={{
              ':hover': {
                textDecoration: 'underline'
              }
            }}
          >
            {user.name}
          </Text>
        </NavLink>
      </TableCell>
      <TableCell />
      <TableCell>
        {user.role && (
          <Badge mr={2} size='medium' variant='info'>
            {t(`roles:${user.role}` as const)}
          </Badge>
        )}
      </TableCell>
      <TableCell>
        <Flex
          flexDirection='row'
          flexWrap='wrap'
          gridRowGap={2}
          gridColumnGap={2}
        >
          {user.tags.map((tag) => (
            <TagBadge key={tag.id} tag={tag}>
              {tag.name}
            </TagBadge>
          ))}
        </Flex>
      </TableCell>
      {/* <TableCell>{user.disabled ? t('common:no') : t('common:yes')}</TableCell> */}
      <TableCell textAlign='right'>
        <UserRowMenu
          user={user}
          isViewer={isViewer}
          onDisable={handleDisableUser}
          onRemove={handleRemoveUser}
        />
      </TableCell>
    </TableRow>
  )
}
